import * as React from 'react';
import { connect } from 'react-redux';
import { requestAPIActions } from 'loopback-react-request';
import { LogoCentered } from 'src/app/Partials';

import { FormattedMessage } from 'react-intl';
import MESSAGES from './RegisterSucceeded.messages';


import './RegisterSucceeded.page.scss';
import { Link } from 'react-router-dom';
import { GlobalPublicState } from 'src/api';

export interface ResendSucceededProps {
  dispatch: Function;
  activateUser: GlobalPublicState['activateUser'];
}

export class ResendSucceededComponent extends React.Component<ResendSucceededProps> {
  componentDidMount() {
    if (this.props.activateUser.result) {
      this.props.dispatch(requestAPIActions.loadCleared('activateUser'));
    }
  }

  public render() {
    return (
      <div className="page-successful d-flex justify-content-center align-items-center h-100">
        <div className="inner w-100 pt-5 pb-5">
          <LogoCentered />
          <div className="col-12">
            <h4>
              <FormattedMessage {...MESSAGES.resendSucceededHeading} />
            </h4>
            <p className="mb-4">
              <FormattedMessage {...MESSAGES.registerSucceededText} />
            </p>
            <Link className="btn btn-secondary w-100 d-block" to="/">
              <FormattedMessage {...MESSAGES.registerSucceededButton} />
            </Link>
          </div>
        </div>
      </div>
    );
  }
}

export const ResendSucceededPage = connect((state: GlobalPublicState) => ({
  activateUser: state.activateUser,
}))(ResendSucceededComponent);

export default ResendSucceededPage;
